import { Icon, IconProps } from '@chakra-ui/react'

export const Denied = ({ height, mt }: IconProps) => {
  return (
    <Icon width="100%" height={height} mt={mt}>
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="247.5 247.5 105.0000000000001 105.0000000000001"
        overflow="visible"
      >
        <g id="Master/Stickers/Denied">
          <g id="denied">
            <g id="stickers_expanded">
              <path
                d="M336.6 267.049C330.42 259.279 318.6 253.519 306.38 252.379C292.646 251.037 278.976 255.492 268.67 264.669C254.67 276.729 248.78 299.669 254.67 319.169C259.42 334.959 271.16 345.169 286.88 347.169C290.565 347.642 294.275 347.883 297.99 347.889C305.67 347.996 313.305 346.715 320.53 344.109C332.26 339.639 340.26 331.519 344.31 319.979C350.68 301.729 347.66 280.999 336.6 267.049Z"
                fill="#FC6E47"
              />
              <path
                id="Path_2"
                d="M319.46 317.7C319.076 317.703 318.7 317.591 318.38 317.38C312.99 313.87 279 286.81 277.56 285.66C276.989 285.219 276.701 284.505 276.804 283.791C276.907 283.078 277.387 282.475 278.059 282.214C278.731 281.953 279.492 282.074 280.05 282.53C280.4 282.81 315.33 310.62 320.56 314.03C321.297 314.516 321.629 315.428 321.375 316.274C321.121 317.12 320.343 317.7 319.46 317.7Z"
                fill="white"
              />
              <path
                id="Path_3"
                d="M282.42 322.25C281.649 322.249 280.948 321.805 280.617 321.109C280.286 320.413 280.384 319.589 280.87 318.99C281.02 318.8 295.87 300.42 299.93 295.32C303.13 291.27 306.56 287.32 309.93 283.43C311.42 281.7 312.93 279.97 314.36 278.26C314.821 277.714 315.538 277.454 316.242 277.58C316.946 277.706 317.529 278.198 317.772 278.87C318.015 279.543 317.881 280.294 317.42 280.84C315.96 282.57 314.42 284.3 312.96 286.04C309.66 289.87 306.25 293.82 303.1 297.8C299.1 302.92 284.17 321.32 284.02 321.51C283.63 321.991 283.039 322.264 282.42 322.25Z"
                fill="white"
              />
            </g>
          </g>
        </g>
      </svg>
    </Icon>
  )
}
